import React from 'react';
import styles from './ClosedEditPage.module.scss';

const ClosedEditPage = () => (
  <div>
    <div className={styles.header}>
      <h1 className={styles.title}>READY… SET…</h1>
      <img
        alt="Edit"
        className={styles.editImage}
        src="https://static.fabfitfun.com/wp-content/uploads/2019/04/EDIT-Logo1_1555117664.8172_1555117664.9642.png"
      />
      <h3 className={styles.description}>
        Check back soon for our next upcoming sale!
      </h3>
      <p className={styles.paragraph}>
        You can view our Events Calendar&nbsp;
        <a
          href="https://support.fabfitfun.com/?a=Events-Calendar---id--H0AQUreNRza2n2P3FrgMww"
          rel="noopener noreferrer"
          target="_blank"
        >
          here
        </a>
        .
      </p>
    </div>
    <div className={styles.content}>
      <div className={styles.contentTextPanel}>
        <h2 className={styles.contentTitle}>What is the Edit Sale?</h2>
        <p className={styles.contentDescription}>
          It's like Add-Ons, but available right now! Shop a curated mix of our
          all-time favorites and brands available for the first time at
          FabFitFun.
        </p>
      </div>
      <div className={styles.contentImagePanel}>
        <img
          alt="The edit sale"
          className={styles.contentImage}
          src="https://static.fabfitfun.com/wp-content/uploads/2018/04/What-is-The-Edit-Sale.png"
        />
      </div>
    </div>
  </div>
);

export default ClosedEditPage;
